import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { SABottomTabs } from '@/components/superadmin/SABottomTabs';
import { SASidebar } from '@/components/superadmin/SASidebar';
import { SAHomeSkeleton } from '@/components/superadmin/SASkeletons';
import { useIsMobile } from '@/hooks/use-mobile';

export default function SuperAdminDashboard() {
  const { session, loading, signOut } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean | null>(null);
  const isMobile = useIsMobile();
  const location = useLocation();

  useEffect(() => {
    if (!session) return;
    const checkRole = async () => {
      const { data } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', session.user.id)
        .eq('role', 'super_admin')
        .maybeSingle();
      setIsSuperAdmin(!!data);
    };
    checkRole();
  }, [session]);

  if (!loading && !session) return <Navigate to="/entrar" replace />;

  if (loading || isSuperAdmin === null) {
    return (
      <div style={{ position: 'fixed', inset: 0, backgroundColor: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: 500, padding: 16 }}>
          <SAHomeSkeleton />
        </div>
      </div>
    );
  }

  if (!isSuperAdmin) return <Navigate to="/entrar" replace />;

  // Hide bottom tabs on user profile page
  const isProfilePage = location.pathname.match(/^\/admin\/usuarios\/.+/);

  return (
    <div className="cms-dark" style={{ position: 'fixed', inset: 0, backgroundColor: '#0A0A0A', overflow: 'hidden' }}>
      {/* Desktop sidebar */}
      {!isMobile && <SASidebar onSignOut={signOut} />}

      {/* Main content */}
      <main style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: isMobile ? 0 : 220,
        overflow: 'auto',
        padding: isMobile ? '16px 16px 72px 16px' : 32,
      }}>
        <Outlet />
      </main>

      {/* Mobile bottom tabs */}
      {isMobile && !isProfilePage && <SABottomTabs />}
    </div>
  );
}
